import { Helmet } from 'react-helmet-async';

interface Props {
  description?: string | null,
  ogDescription?: string | null,
}

export const PageMetaDescription: React.FC<Props> = ({
  description,
  ogDescription,
}) => {
  if (description) {
    return (
      <Helmet>
        <meta name="description" content={description} />

        <meta property="og:description" content={ogDescription || description} />
        <meta name="twitter:description" content={ogDescription || description} />
      </Helmet>
    );
  }

  return null;
};
